import React, { useState, useEffect, useMemo } from 'react';
import CommonMessage from "../components/CommonMessage";
import { contractCall, web3AccountCheck } from '../helper/web3helper';
import hostContract from '../web3/hostContract.json';
import web3Config from '../web3/web3Config.json';
import { formatEmailDetails, formatMessageList } from '../helper/dataFormatHelper';
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useWalletReconnectionWithLoader } from '../helper/useWalletReconnection';
import { getEmails } from '../helper/emailHelper';
import { getHostContract } from '../helper/contract-helper';
import Web3 from "web3";
import { reportError, toErrorString } from '../utils/errorLogger';

const cookies = new Cookies();

function Home() {
  const dispatch = useDispatch();
  const [user] = useState(cookies.get("userObject"));
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [web3Contract, setWeb3Contract] = useState('');
  const [allBoxList, setAllBoxList] = useState([]);
  const [readList, setReadList] = useState([]);
  const [unreadList, setUnreadList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [text, setText] = useState("")
  const refreshCount = useSelector((state) => state.refreshCount);
  const userName = user.name;
  const [count, setCount] = useState(0);
  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
  }, []);

  useWalletReconnectionWithLoader(
    setLoader,
    setText,
    web3AccountCheck,
    setWeb3,
    setAccount,
    () => handleClickOutside(true),
    web3Contract
  );

  useEffect(() => {
    const hostContract = getHostContract(true);
    // No WSS_RPC_URL configured (or WS node unreachable) → no live event stream; inbox still works.
    if (!hostContract) return;
    const eventListener = hostContract.events?.EmailCreated;
    if (eventListener) {
      const eventStream = eventListener({
        fromBlock: 'latest',
      });
      eventStream.on("data", async (event) => {
        const usernameHash = Web3.utils.keccak256(userName);
        const senderHash = event.returnValues.senderName.hash;
        const recipientHash = event.returnValues.recipient.hash;
        if (usernameHash !== senderHash && usernameHash == recipientHash) {
          const messageList = document.getElementById("list-message-component");
          const replyModal = document.getElementById("reply-modal");
          const composeEmail = document.getElementById("compose-email-send");
          if (!replyModal && !composeEmail && window.ncogProvider) {
            setEmail(true);
          }
        }
      });
    } else {

      console.error("EventAddedOrEdited is not defined in ABI or Web3 setup.");
    }
  }, [account]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const messageList = document.getElementById("list-message-component");
  //     const replyModal = document.getElementById("reply-modal");
  //     const composeEmail = document.getElementById("compose-email-send");
  //     if ( !replyModal && !composeEmail) {
  //       web3AccountCheck(setWeb3, setAccount);
  //     }
  //   }, 5000);
  //   return () => clearInterval(interval);
  // }, []);


  const handleClickOutside = async (event) => {
    if (event) {
      web3AccountCheck(setWeb3, setAccount);
      await setEmail();
    }
  };
  useEffect(() => {
    handleClickOutside(true);
  }, []);



  const getRefreshMessage = useSelector((state) => state.refreshMessage);
  useEffect(() => {
    handleClickOutside(true);
  }, [getRefreshMessage]);

  // Auto-refresh inbox when global refreshCount toggles (e.g., new mail notification)
  useEffect(() => {
    if (web3Contract) {
      setEmail(true);
    }
  }, [refreshCount, web3Contract]);

  // Also listen for window REFRESH_COUNT events (emitted by Notifications)
  useEffect(() => {
    const handler = () => setEmail(true);
    window.addEventListener("REFRESH_COUNT", handler);
    return () => window.removeEventListener("REFRESH_COUNT", handler);
  }, []);


  useEffect(() => {
    if (account && web3Value) {
      // const contractInstance = new web3Value.eth.Contract(hostContract.contract, web3Config.CONTRACT);
      const contractInstance = contractCall(hostContract.contract, web3Config.CONTRACT);
      if (contractInstance) setWeb3Contract(contractInstance);
    }
  }, [web3Value, account]);


  useEffect(() => {
    if (web3Contract) {
      setEmail(true);
    }
  }, [web3Contract]);


  useEffect(() => {
    if (web3Contract) {
      setEmail();
    }
  }, []);


  async function setEmail(autoFetch = false) {
    try {
      if (!web3Contract) return;
      if (!autoFetch) {
        setLoader(true);
        setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
      }
      const emailList = await getEmails(userName);
      const updatedEmailList = await formatEmailDetails(emailList);
      const formattedEmailList = updatedEmailList.filter(({ senderName }) => senderName)
        .map(({ id, subject, encryptedData, receivedDate, isStarred, senderName, isRead, emailDetails, isCC, isBCC, ...rest }) => ({
          id: parseInt(id),
          subject,
          encryptedData,
          receivedDate,
          created_at: receivedDate,
          isStarred: isStarred,
          sender: senderName,
          isRead,
          header: emailDetails,
          isCC,
          isBCC,
          mailtype: "web3emails",
          ...rest
        })).filter(data => data.attributes).filter(data => !data.attributes.value && !data.isDeleted && !data.isArchive && (data.isfolder === "false" || !data.isfolder) && !data.isSaved);
      const { allList, readList, unReadList } = await formatMessageList(formattedEmailList.reverse(), "Inbox");
      if (autoFetch && count < emailList.length) {
        setAllBoxList(allList);
        setReadList(readList);
        setUnreadList(unReadList);
        dispatch({ type: "REFRESH_COUNT", payload: !refreshCount })
      } else if (!autoFetch) {
        setAllBoxList(allList);
        setReadList(readList);
        setUnreadList(unReadList);
        dispatch({ type: "REFRESH_COUNT", payload: !refreshCount })
      }
      setCount(emailList.length);
      setLoader(false)
      setText("")
    } catch (error) {
      const userName = localStorage.getItem('UserName');
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: Home.js, Fun: setEmail, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.log("error", error);
    }
  }

  const reRender = () => {
    dispatch({ type: "REFRESH_COUNT", payload: !refreshCount })
    setEmail();
  }

  const memoizedCommonMessage = useMemo(() => {
    return (
      <CommonMessage
        messageList={allBoxList}
        unreadList={unreadList}
        readList={readList}
        pageType={"Inbox"}
        loader={loader}
        reRender={reRender}
        text={text}
      />
    );
  }, [allBoxList, unreadList, readList, loader]);


  return (
    <div className="inbox-container">
      {memoizedCommonMessage}
    </div>
  );
}

export default Home;
